/**
 * Module definition for widgets module. The widgets module manages
 * the application's top-level widgets view (i.e., /widgets).
 *
 * @module routes.simulation.widgets
 */

angular.module('routes.simulation.widgets', [
  'stack',
  'routes.simulation.widgets.constants',
  'routes.simulation.widgets.SimulationWidgetsController',
  'routes.simulation.widgets.SimulationWidgetsPayloadResolver'
])
.config(
  [
    '$stateProvider',
    function ($stateProvider) {
      'use strict';

      $stateProvider
        .state('routes.simulation.states.widgets', {
          url: '/widgets/:widgetId',
          templateUrl: 'routes/simulation/widgets/widgets.html',
          controller: 'SimulationWidgetsController',
          params: {
            widgetId: {
              value: null,
              squash: true
            }
          },
          resolve: {
            constants: [
              'ConstantResolver',
              'WIDGETS',
              function (ConstantResolver, WIDGETS) {
                return new ConstantResolver(WIDGETS);
              }
            ],
            widgetsPayload: [
              'SimulationWidgetsPayloadResolver',
              '$stateParams',
              'simulationPayload',
              function (SimulationWidgetsPayloadResolver, $stateParams, simulationPayload) {
                return new SimulationWidgetsPayloadResolver($stateParams, simulationPayload);
              }
            ]
          }
        }
      );
    }
  ]
);
